module.exports = __webpack_public_path__ + "static/img/volume-bar.cb74f2d1.svg";